import { Component, Inject } from '@angular/core';
import { BlanketPurchaseRecord } from '../../../shared/models/app-models/BlanketPurchaseDocument.model';
import { SelectionModel } from '@angular/cdk/collections';
import { BlanketPurchaseColumns } from '../../shared/constants';
import { BaseTableColumn } from 'src/app/shared/models/app-models/BaseTableColumn.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-reference-dialog',
  templateUrl: './add-reference-dialog.component.html',
  styleUrls: ['./add-reference-dialog.component.scss']
})
export class AddReferenceDialogComponent {
  blanketPurchaseRecords: BlanketPurchaseRecord[] = [];
  blanketPurchaseColumns: BaseTableColumn<BlanketPurchaseRecord>[] = BlanketPurchaseColumns
  selectedData: SelectionModel<BlanketPurchaseRecord> = new SelectionModel<BlanketPurchaseRecord>(true, []);
  constructor(public matDialogRef: MatDialogRef<BlanketPurchaseRecord>, @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log('myData')
    console.log(data)
    if (data.blanketPurchaseType=='any')
    this.blanketPurchaseRecords.push({
      DocumentNumber: 'ABCD',
      PurposeOfPurchase: 'Some purpose',
      BlanketType: 'AOR only',
      BalanceAmount: 1234,
    })
    else if (data.blanketPurchaseType=='aor+woc')
    this.blanketPurchaseRecords.push({
      DocumentNumber: 'EFGH',
      PurposeOfPurchase: 'Some purpose',
      BlanketType: 'AOR',
      BalanceAmount: 1234,
    },{
      DocumentNumber: 'IJKL',
      PurposeOfPurchase: 'Some purpose',
      BlanketType: 'WOC',
      BalanceAmount: 1234,
    })
    for (const record of this.blanketPurchaseRecords) {
      if (data.selectedRecordsArray.find((x:BlanketPurchaseRecord)=>x.DocumentNumber==record.DocumentNumber))
        this.selectedData.select(record)
    }
  }
  onSubmit() {
    const selectedRecords: BlanketPurchaseRecord[] = []
    for (const record of this.blanketPurchaseRecords) {
      if (this.selectedData.isSelected(record))
        selectedRecords.push(record as BlanketPurchaseRecord)
    }
    console.log(selectedRecords)
    this.matDialogRef.close(selectedRecords)
  }
}
